const QuickLinksList = props => {
  const { children, isKnowledgeBase } = props
  let quickLinksListClassName = 'content--centered'
  if (children.length >= 5 && children.length % 3 === 2) {
    quickLinksListClassName += ' fill-space'
  }
  if (isKnowledgeBase) {
    quickLinksListClassName += ' content--centered quicklink__container--knowledgeBase'
  } else {
    quickLinksListClassName += ' quicklink__container'
  }

  return (
    children &&
      <ul class={quickLinksListClassName}>
        {children}
      </ul>
  )
}

export default QuickLinksList
